import { render, staticRenderFns } from "./LiveQuizHost.vue?vue&type=template&id=5e36ae61&scoped=true"
import script from "./LiveQuizHost.vue?vue&type=script&lang=js"
export * from "./LiveQuizHost.vue?vue&type=script&lang=js"
import style0 from "./LiveQuizHost.vue?vue&type=style&index=0&id=5e36ae61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36ae61",
  null
  
)

export default component.exports